<template>
  <div class="ird">
    <table class="ird-table">
      <thead>
        <tr>
          <th class="ird-th">Influencer</th>
          <th class="ird-th ird-th--right">Posts</th>
          <th class="ird-th ird-th--right">Feed</th>
          <th class="ird-th ird-th--right">Story</th>
          <th class="ird-th ird-th--right">Reach</th>
          <th class="ird-th ird-th--right ird-th--accent">Impressions</th>
          <th class="ird-th ird-th--right">Engagement</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in items" :key="item.influencer_id" class="ird-row">
          <td class="ird-td ird-td--influencer">
            <span class="ird-dot" :style="{ background: dotColor(index) }"></span>
            <div class="ird-avatar">{{ initials(item) }}</div>
            <div>
              <div class="ird-name">{{ item.first_name }} {{ item.last_name }}</div>
              <div v-if="item.username" class="ird-handle">@{{ item.username }}</div>
            </div>
          </td>
          <td class="ird-td ird-td--right">{{ item.posts | local_numbers }}</td>
          <td class="ird-td ird-td--right">{{ item.feed_posts | local_numbers }}</td>
          <td class="ird-td ird-td--right">{{ item.story_posts | local_numbers }}</td>
          <td class="ird-td ird-td--right">{{ item.reach | local_numbers }}</td>
          <td class="ird-td ird-td--right ird-td--accent">{{ item.impressions | local_numbers }}</td>
          <td class="ird-td ird-td--right">{{ engagementRate(item) }}</td>
        </tr>
        <!-- Total row -->
        <tr v-if="items.length > 0" class="ird-row ird-row--total">
          <td class="ird-td ird-td--influencer"><strong>Total</strong></td>
          <td class="ird-td ird-td--right"><strong>{{ totals.posts | local_numbers }}</strong></td>
          <td class="ird-td ird-td--right"><strong>{{ totals.feed_posts | local_numbers }}</strong></td>
          <td class="ird-td ird-td--right"><strong>{{ totals.story_posts | local_numbers }}</strong></td>
          <td class="ird-td ird-td--right"><strong>{{ totals.reach | local_numbers }}</strong></td>
          <td class="ird-td ird-td--right"><strong>{{ totals.impressions | local_numbers }}</strong></td>
          <td class="ird-td ird-td--right"></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import local_numbers from "@/helpers/filters/local_numbers";

const DOT_COLORS = ['#27ae60','#8e44ad','#e05540','#e91e8c','#2980b9','#16a085','#f39c12','#2c3e50','#c0392b','#1abc9c'];

export default {
  filters: { local_numbers },
  props: {
    items: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  },
  computed: {
    totals() {
      return this.items.reduce((acc, item) => {
        acc.posts       += item.posts || 0;
        acc.feed_posts  += item.feed_posts || 0;
        acc.story_posts += item.story_posts || 0;
        acc.reach       += item.reach || 0;
        acc.impressions += item.impressions || 0;
        return acc;
      }, { posts: 0, feed_posts: 0, story_posts: 0, reach: 0, impressions: 0 });
    },
  },
  methods: {
    dotColor(index) { return DOT_COLORS[index % DOT_COLORS.length]; },
    initials(item) {
      return ((item.first_name?.[0] || '') + (item.last_name?.[0] || '')).toUpperCase();
    },
    engagementRate(item) {
      if (!item.engagement || !item.reach) return '—';
      return ((item.engagement / item.reach) * 100).toFixed(1) + '%';
    },
  },
};
</script>

<style lang="scss" scoped>
.ird { overflow-x: auto; }

.ird-table {
  width: 100%; border-collapse: collapse;
}

.ird-th {
  font-size: 10.5px; font-weight: 700; color: var(--ink-3, #999);
  text-transform: uppercase; letter-spacing: 0.4px;
  padding: 10px 16px; text-align: left;
  border-bottom: 1px solid var(--line, #e8e8e8);
  white-space: nowrap;
  &--right { text-align: right; }
  &--accent { color: #e05540; }
}

.ird-row {
  border-bottom: 1px solid var(--line, #f0f0f0);
  &:last-child { border-bottom: none; }
  &:hover:not(.ird-row--total) { background: var(--surface-2, #fafafa); }
  &--total { border-top: 2px solid var(--line, #e8e8e8); }
}

.ird-td {
  padding: 12px 16px; font-size: 13px; color: var(--ink-1, #1a1a1a);
  &--right { text-align: right; }
  &--accent { color: #e05540; font-weight: 600; }
  &--influencer {
    display: flex; align-items: center; gap: 10px; white-space: nowrap;
  }
}

.ird-dot {
  width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0;
}

.ird-avatar {
  width: 28px; height: 28px; border-radius: 50%;
  background: var(--surface-2, #f0f0f0);
  color: var(--ink-3, #888); font-size: 10px; font-weight: 700;
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
}

.ird-name { font-weight: 500; }

.ird-handle {
  font-size: 11px;
  color: var(--ink-3, #999);
  font-weight: 400;
  margin-top: 1px;
}
</style>